exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.demo-dynamic[data-v-479bea16]{\r\n  background-color: #f6f6f6;\r\n  padding-top: 5px;\r\n  padding-bottom: 5px;\n}\r\n", ""]);

// exports
